module.exports = __webpack_public_path__ + "img/activity3.db632efa.jpg";